export const SplitWindowIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.6667 3H15.4444C16.3 3 17 3.65961 17 4.4658V15.5342C17 16.3404 16.3 17 15.4444 17H4.55556C3.69222 17 3 16.3404 3 15.5342V4.4658C3 3.65961 3.69222 3 4.55556 3H5.33333H7.03844H12.9883H14.6667ZM4.55556 15.5342H15.4444V11.5287L4.55556 11.5287V15.5342ZM4.55556 10.0287V6.17898H15.4444V10.0287L4.55556 10.0287Z"
        fill="#787878"
      />
    </svg>
  )
}
